"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactChartjs = require("react-chartjs-2");

var _chartjsPluginDatalabels = _interopRequireDefault(require("chartjs-plugin-datalabels"));

var _utils = _interopRequireDefault(require("../../../utils"));

var _Flex = _interopRequireDefault(require("../../Flex/Flex"));

var _customHooks = _interopRequireDefault(require("../../../customHooks"));

var _utils2 = require("../utils");

var _quadrantsPlugin = _interopRequireDefault(require("./quadrantsPlugin"));

var _excluded = ["dataset", "unit", "axisDecimalPlaces", "xAxisLabel", "quadrantDescriptions", "yAxisLabel", "showQuadrantDescriptions", "min", "max", "disableAllAnimation", "showDataLabels", "graphOptions", "hideTooltip"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Matrix = function Matrix(_ref) {
  var _containerRef$current;

  var containerRef = _ref.containerRef,
      dataset = _ref.dataset,
      unit = _ref.unit,
      quadrantDescriptions = _ref.quadrantDescriptions,
      xAxisLabel = _ref.xAxisLabel,
      yAxisLabel = _ref.yAxisLabel,
      disableAllAnimation = _ref.disableAllAnimation,
      axisDecimalPlaces = _ref.axisDecimalPlaces,
      showDataLabels = _ref.showDataLabels,
      min = _ref.min,
      max = _ref.max,
      hideTooltip = _ref.hideTooltip,
      graphOptions = _ref.graphOptions,
      showQuadrantDescriptions = _ref.showQuadrantDescriptions;

  var device = _customHooks["default"].useClientDevice();

  var indicatorVisible = _customHooks["default"].useElementVisibleTrigger({
    componentRef: containerRef,
    delay: 0
  });

  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    position: "relative",
    height: "95%",
    width: "100%",
    className: "chart-container"
  }, /*#__PURE__*/_react["default"].createElement(_reactChartjs.Bubble, {
    data: (0, _utils2.radiusPointManipulator)({
      dataset: dataset,
      device: device,
      graphWidth: containerRef == null ? void 0 : (_containerRef$current = containerRef.current) == null ? void 0 : _containerRef$current.offsetWidth,
      forceDataZero: !disableAllAnimation && !indicatorVisible
    }),
    plugins: [_quadrantsPlugin["default"], _chartjsPluginDatalabels["default"]],
    options: _utils["default"].deepMerge({
      responsive: true,
      animation: disableAllAnimation ? false : {
        delay: 10
      },
      hover: hideTooltip ? {
        mode: null
      } : {},
      plugins: {
        quadrants: {
          device: device,
          quadrantDescriptions: quadrantDescriptions,
          showQuadrantDescriptions: showQuadrantDescriptions
        },
        legend: false,
        tooltip: hideTooltip ? false : {
          callbacks: {
            label: function label(d) {
              return d.raw.label;
            }
          }
        },
        datalabels: showDataLabels ? {
          display: function display(context) {
            return context.dataset.data[context.dataIndex].r > 10;
          },
          font: {
            weight: "bold"
          },
          formatter: function formatter(value) {
            return value.overrideDataLabel ? value.overrideDataLabel : Math.round(value.originalR);
          }
        } : false
      },
      scales: {
        y: {
          min: min,
          max: max,
          ticks: {
            callback: function callback(value, index, values) {
              var roundedValue = value.toFixed(axisDecimalPlaces);

              if (unit && (values.length - 1 === index || index === 0)) {
                return "" + roundedValue + unit;
              }

              return roundedValue;
            },
            font: {
              size: device === "MOBILE" ? 10 : 14
            }
          },
          title: {
            font: {
              size: device === "MOBILE" ? 10 : 16
            },
            padding: {
              top: device === "MOBILE" ? 0 : 20,
              left: 0,
              right: 0,
              bottom: 0
            },
            text: yAxisLabel,
            display: true
          }
        },
        x: {
          min: min,
          max: max,
          ticks: {
            callback: function callback(value, index, values) {
              var roundedValue = value.toFixed(axisDecimalPlaces);

              if (unit && (values.length - 1 === index || index === 0)) {
                return "" + roundedValue + unit;
              }

              return roundedValue;
            },
            font: {
              size: device === "MOBILE" ? 10 : 14
            }
          },
          title: {
            font: {
              size: device === "MOBILE" ? 10 : 16
            },
            padding: {
              top: device === "MOBILE" ? 0 : 20,
              left: 0,
              right: 0,
              bottom: 0
            },
            text: xAxisLabel,
            display: true
          }
        }
      }
    }, graphOptions)
  }));
};
/**
 * A autoscaling matrix chart to show trends in data through bubbles across quadrants.
 *
 * Uses Chart.js to create a opinionated bar chart that can handle displaying a set of data.
 *
 * To learn more about how to use this component, see examples within Storybook.
 *
 * @param {object} props React components passed in props
 * @param {object} [props.dataset] The data to display
 * @param {object[]} [props.dataset.datasets] Datasets to show per label
 * @param {number[]} [props.dataset.datasets.data] Array of number values aligning with label index
 * @param {string} [props.dataset.datasets.label] Label of dataset (required but not visible)
 * @param {boolean} [props.disableAllAnimation] Disables animation
 * @param {number} [props.axisDecimalPlaces] Number of decimal places for ticks on Y and X axis
 * @param {string} [props.unit] Unit to display on Y and X axis
 * @param {object} [props.graphOptions] Can add / override options passed into chart.js
 * @param {boolean} [props.showDataLabels] Shows values on bubbles
 * @param {boolean} [props.hideTooltip] Disables tooltip while hovering bubbles
 * @param {string} [props.xAxisLabel] Title on X axis
 * @param {string} [props.yAxisLabel] Title on Y axis
 * @param {string} [props.min] Min value on X and Y axis
 * @param {string} [props.max] Max value on X and Y axis
 * @param {boolean} [props.showQuadrantDescriptions] Show quadrant descriptions
 * @param {object} [props.quadrantDescriptions] Quadrant descriptions
 */


var MatrixChart = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var dataset = _ref2.dataset,
      _ref2$unit = _ref2.unit,
      unit = _ref2$unit === void 0 ? "" : _ref2$unit,
      _ref2$axisDecimalPlac = _ref2.axisDecimalPlaces,
      axisDecimalPlaces = _ref2$axisDecimalPlac === void 0 ? 0 : _ref2$axisDecimalPlac,
      _ref2$xAxisLabel = _ref2.xAxisLabel,
      xAxisLabel = _ref2$xAxisLabel === void 0 ? "" : _ref2$xAxisLabel,
      _ref2$quadrantDescrip = _ref2.quadrantDescriptions,
      quadrantDescriptions = _ref2$quadrantDescrip === void 0 ? {} : _ref2$quadrantDescrip,
      _ref2$yAxisLabel = _ref2.yAxisLabel,
      yAxisLabel = _ref2$yAxisLabel === void 0 ? "" : _ref2$yAxisLabel,
      _ref2$showQuadrantDes = _ref2.showQuadrantDescriptions,
      showQuadrantDescriptions = _ref2$showQuadrantDes === void 0 ? false : _ref2$showQuadrantDes,
      _ref2$min = _ref2.min,
      min = _ref2$min === void 0 ? 0 : _ref2$min,
      _ref2$max = _ref2.max,
      max = _ref2$max === void 0 ? 100 : _ref2$max,
      _ref2$disableAllAnima = _ref2.disableAllAnimation,
      disableAllAnimation = _ref2$disableAllAnima === void 0 ? false : _ref2$disableAllAnima,
      _ref2$showDataLabels = _ref2.showDataLabels,
      showDataLabels = _ref2$showDataLabels === void 0 ? false : _ref2$showDataLabels,
      _ref2$graphOptions = _ref2.graphOptions,
      graphOptions = _ref2$graphOptions === void 0 ? {} : _ref2$graphOptions,
      _ref2$hideTooltip = _ref2.hideTooltip,
      hideTooltip = _ref2$hideTooltip === void 0 ? false : _ref2$hideTooltip,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
  var containerRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    ref: containerRef,
    height: "100%",
    width: "100%",
    flexDirection: "column"
  }, props), /*#__PURE__*/_react["default"].createElement(Matrix, {
    dataset: dataset,
    unit: unit,
    xAxisLabel: xAxisLabel,
    yAxisLabel: yAxisLabel,
    quadrantDescriptions: quadrantDescriptions,
    min: min,
    max: max,
    disableAllAnimation: disableAllAnimation,
    hideTooltip: hideTooltip,
    axisDecimalPlaces: axisDecimalPlaces,
    showQuadrantDescriptions: showQuadrantDescriptions,
    containerRef: containerRef,
    graphOptions: graphOptions,
    showDataLabels: showDataLabels
  }));
}, _utils["default"].areEqual);

var _default = MatrixChart;
exports["default"] = _default;